import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { STATE_BPPROFILES_MAIN } from '@app/shared/app-states';
import { BPProfilesDataService } from './bp-profiles-data.service';
import { BPProfilesService } from './bp-profiles.service';
import { BPProfilesComponent } from './bp-profiles.component';
import { BP_ADVANCED_STATES } from './advanced/bp-profiles-advanced.routes';
import { TranslationCategory } from '@app/shared/services/ga-state.service';
import { BPProfilesAttributesService } from './profile-attributes/bp-profiles-attributes.service';
import { BP_WIZARD_STATES } from './wizard/bp-wizard.routes';
import { BPWizardComponent } from './wizard/bp-wizard.component';
import { BPWizardAgreementComponent } from './wizard/agreement/bp-wizard-agreement.component';
import { BPWizardBankComponent } from './wizard/bank/bp-wizard-bank.component';
import { BPWizardBillingMethodsComponent } from './wizard/billing-methods/bp-wizard-billing-methods.component';
import { BPWizardCompanyMarginComponent } from './wizard/company-margin/bp-wizard-company-margin.component';
import { BPWizardFeesComponent } from './wizard/fees/bp-wizard-fees.component';
import { BPWizardGeneralComponent } from './wizard/general/bp-wizard-general.component';
import { BPWizardOEMComponent } from './wizard/oem/bp-wizard-oem.component';
import { BPWizardPaymentSourceComponent } from './wizard/payment-source/bp-wizard-payment-source.component';
import { BPWizardPaymentTermsComponent } from './wizard/payment-terms/bp-wizard-payment-terms.component';
import { BPWizardThankYouComponent } from './wizard/thank-you/bp-wizard-thank-you.component';
import { BPWizardWelcomeComponent } from './wizard/welcome/bp-wizard-welcome.component';
import { BPProfilesAdvancedComponent } from './advanced/bp-profiles-advanced.component';
import { BPProfilesRelationsComponent } from './advanced/bp-relations/bp-profiles-relations.component';
import { BPProfilesProductCatalogComponent } from './advanced/product-catalog/bp-profiles-product-catalog.component';
import { BPProfilesReportDialogComponent } from './advanced/bp-profiles-report-dialog.component';
import { BPProfilesGeneralInfoComponent } from './advanced/general-info/bp-profiles-general-info.component';
import { BPProfilesBankComponent } from './advanced/bank/bp-profiles-bank.component';
import { BPProfilesAccessSettingsComponent } from './advanced/access-settings/bp-profiles-access-settings.component';
import { BPProfilesAcslInfoComponent } from './advanced/acsl-info/bp-profiles-acsl-info.component';
import { BPProfilesContactsComponent } from './advanced/contacts/bp-profiles-contacts.component';
import { BPProfilesOEMComponent } from './advanced/oem/bp-profiles-oem.component';
import { BPProfilesOEMOverviewComponent } from './advanced/oem/bp-profiles-oem-overview.component';
import { BPProfilesOEMDetailComponent } from './advanced/oem/detail/bp-profiles-oem-detail.component';
import { BPProfilesSurveyComponent } from './advanced/survey/bp-profiles-survey.component';
import { BPProfilesAccreditationsComponent } from './advanced/accreditations/bp-profiles-accreditations.component';
import { BPProfilesDocumentsComponent } from './advanced/documents/bp-profiles-documents.component';
import { BPProfilesLocationsComponent } from './advanced/locations/bp-profiles-locations.component';
import { AgLocationDetailComponent } from './advanced/locations/ag-location-detail.component';
import { OEMAddDistributorDialogComponent } from './advanced/oem/dialogs/oem-add-distributor-dialog.component';
import { OEMChangeRankingDialogComponent } from './advanced/oem/dialogs/oem-change-ranking-dialog.component';
import { OEMTierStatusDialogComponent } from './advanced/oem/dialogs/oem-tier-status-dialog.component';
import { BPProfilesDashboardComponent } from './advanced/dashboard/bp-profiles-dashboard.component';
import { BPProfilesAuditComponent } from './advanced/audit/bp-profiles-audit.component';
import { BPProfilesCatalogComponent } from './advanced/catalog/bp-profiles-catalog.component';
import { BPProfilesCatalogOverviewComponent } from './advanced/catalog/bp-profiles-catalog-overview.component';
import { BPProfilesCatalogDetailComponent } from './advanced/catalog/detail/bp-profiles-catalog-detail.component';
import { BPProfilesTicketsComponent } from './advanced/tickets/bp-profiles-tickets.component';
import { BPProfilesInvoiceComponent } from './advanced/invoice/bp-profiles-invoice.component';
import { BPProfilesInvoiceOverviewComponent } from './advanced/invoice/bp-profiles-invoice-overview.component';
import { BPProfilesInvoiceDetailComponent } from './advanced/invoice/detail/bp-profiles-invoice-detail.component';
import { BPProfilesTerritoriesComponent } from './advanced/territories/bp-profiles-territories.component';
import { BPProfilesMailsComponent } from './advanced/mails/bp-profiles-mails.component';
import { BPProfilesTCComponent } from './advanced/tc/bp-profiles-tc.component';
import { BPProfilesCaveatsComponent } from './advanced/caveats/bp-profiles-caveats.component';
import { BPProfilesContractComponent } from './advanced/contract/bp-profiles-contract.component';
import { BPProfilesSLAComponent } from './advanced/sla/bp-profiles-sla.component';
import { BPProfilesSLADefinitionsComponent } from './advanced/sla/bp-profiles-sla-definitions.component';
import { BPProfilesChecklistsComponent } from './advanced/checklists/bp-profiles-checklists.component';
import { ContractAgreedComponent } from './advanced/contract/contract-agreed.component';
import { AddAccreditationsDialogComponent } from './advanced/accreditations/add-accreditations-dialog.component';
import { PaypalConnectDialogComponent } from './advanced/bank/paypal-connect-dialog.component';
import { EditContactInfoDialogComponent } from './advanced/contacts/edit-contact-info-dialog.component';
import { ContactRoleDialogComponent } from './advanced/contacts/contact-role-dialog.component';
import { RankingLabelComponent } from './advanced/acsl-info/ranking-label.component';
import { OFTDetailComponent } from './advanced/oem/detail/oft-detail.component';
import { CLFDetailComponent } from './advanced/oem/detail/clf-detail.component';
import { BPProfilesLocationsDialogComponent } from './advanced/locations/bp-profiles-locations-dialog.component';
import { AddEditDocumentDialogComponent } from './advanced/documents/add-edit-document-dialog.component';
import { BPProfilesAttributesComponent } from './profile-attributes/bp-profiles-attributes.component';
import { BPProfilesAttributesValueComponent } from './profile-attributes/bp-profiles-attributes-value.component';
import { BPProfilesProductCatalogDataService } from './advanced/product-catalog/bp-profiles-product-catalog-data.service';
import { BPProfilesBankDataService } from './advanced/bank/bp-profiles-bank-data.service';
import { BPProfilesAccessSettingsDataService } from './advanced/access-settings/bp-profiles-access-settings-data.service';
import { BPProfilesAcslInfoDataService } from './advanced/acsl-info/bp-profiles-acsl-info-data.service';
import { BPProfilesContactsDataService } from './advanced/contacts/bp-profiles-contacts-data.service';
import { BPProfilesOEMService } from './advanced/oem/bp-profiles-oem.service';
import { BPProfilesOEMDataService } from './advanced/oem/bp-profiles-oem-data.service';
import { BPProfilesTCDataService } from './advanced/tc/bp-profiles-tc-data.service';
import { BPProfilesAccreditationsDataService } from './advanced/accreditations/bp-profiles-accreditations-data.service';
import { BPProfilesAuditDataService } from './advanced/audit/bp-profiles-audit-data.service';
import { BPProfilesCatalogDataService } from './advanced/catalog/bp-profiles-catalog-data.service';
import { BPProfilesCatalogService } from './advanced/catalog/bp-profiles-catalog.service';
import { BPProfilesDocumentsDataService } from './advanced/documents/bp-profiles-documents-data.service';
import { BPProfilesTicketsDataService } from './advanced/tickets/bp-profiles-tickets-data.service';
import { BPProfilesMailsDataService } from './advanced/mails/bp-profiles-mails-data.service';
import { BPProfilesMailsService } from './advanced/mails/bp-profiles-mails.service';
import { BPProfilesTerritoriesDataService } from './advanced/territories/bp-profiles-territories-data.service';
import { BPProfilesContractDataService } from './advanced/contract/bp-profiles-contract-data.service';
import { BPProfilesCaveatsDataService } from './advanced/caveats/bp-profiles-caveats-data.service';
import { BPProfilesSLADataService } from './advanced/sla/bp-profiles-sla-data.service';
import { BPProfilesSLAService } from './advanced/sla/bp-profiles-sla.service';
import { BPProfilesChecklistsDataService } from './advanced/checklists/bp-profiles-checklists-data.service';
import { BPWizardService } from './wizard/bp-wizard.service';
import { UIRouterConfigFn } from '@type_definitions/vendor';
import { UIRouter } from '@uirouter/core';
import { FormsModule } from '@angular/forms';
import { ReportModule } from '@app/main/report/report.module';
import { UIRouterModule } from '@uirouter/angular';
import { GaStateDeclaration } from '@type_definitions/datatypes';
import { BPProfilesAccreditationsService } from './advanced/accreditations/bp-profiles-accreditations.service';
import { EditAccreditationDialogComponent } from './advanced/accreditations/edit-accreditation-dialog.component';
import { BPProfilesInternalConfigComponent } from './advanced/internal-config/bp-profiles-internal-config.component';
import { TRANSLATION_READY_RESOLVER } from '@app/app-routes.config';

const config:UIRouterConfigFn = (uiRouterInstance:UIRouter, injector:Injector) => {
  const bpProfilesService:BPProfilesService = injector.get(BPProfilesService);
  uiRouterInstance.urlService.rules.when(bpProfilesService.bpProfileUrlReplace.regex, bpProfilesService.bpProfileUrlReplace.result);
};

export const BP_MAIN_STATES:GaStateDeclaration[] = [
  {
    name: STATE_BPPROFILES_MAIN,
    abstract: true,
    views: {
      content: {
        component: BPProfilesComponent
      }
    },
    data: {
      translate: true,
      modules: [TranslationCategory.BPPROFILES, TranslationCategory.DASHBOARD, TranslationCategory.INVOICE, TranslationCategory.BPWIZARD],
      languages: ['de']
    },
    resolve: [
      TRANSLATION_READY_RESOLVER
    ]
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReportModule,
    SharedModule,
    UIRouterModule.forChild({
      states: [].concat(BP_MAIN_STATES, BP_ADVANCED_STATES, BP_WIZARD_STATES),
      config
    })
  ],
  declarations: [
    BPProfilesComponent,
    // -- BP advanced
    BPProfilesAdvancedComponent,
    BPProfilesRelationsComponent,
    BPProfilesProductCatalogComponent,
    BPProfilesReportDialogComponent,
    BPProfilesGeneralInfoComponent,
    BPProfilesBankComponent,
    BPProfilesAccessSettingsComponent,
    BPProfilesAcslInfoComponent,
    BPProfilesContactsComponent,
    BPProfilesOEMComponent,
    BPProfilesOEMOverviewComponent,
    BPProfilesOEMDetailComponent,
    BPProfilesSurveyComponent,
    BPProfilesDocumentsComponent,
    BPProfilesLocationsComponent,
    AgLocationDetailComponent,
    OEMAddDistributorDialogComponent,
    OEMChangeRankingDialogComponent,
    OEMTierStatusDialogComponent,
    BPProfilesDashboardComponent,
    BPProfilesAccreditationsComponent,
    BPProfilesAuditComponent,
    BPProfilesCatalogComponent,
    BPProfilesCatalogOverviewComponent,
    BPProfilesCatalogDetailComponent,
    BPProfilesTicketsComponent,
    BPProfilesInvoiceComponent,
    BPProfilesInvoiceOverviewComponent,
    BPProfilesInvoiceDetailComponent,
    BPProfilesTerritoriesComponent,
    BPProfilesMailsComponent,
    BPProfilesTCComponent,
    BPProfilesCaveatsComponent,
    BPProfilesContractComponent,
    BPProfilesSLAComponent,
    BPProfilesSLADefinitionsComponent,
    BPProfilesChecklistsComponent,
    ContractAgreedComponent,
    AddAccreditationsDialogComponent,
    EditAccreditationDialogComponent,
    PaypalConnectDialogComponent,
    EditContactInfoDialogComponent,
    ContactRoleDialogComponent,
    RankingLabelComponent,
    OFTDetailComponent,
    CLFDetailComponent,
    BPProfilesLocationsDialogComponent,
    AddEditDocumentDialogComponent,
    BPProfilesAttributesComponent,
    BPProfilesAttributesValueComponent,
    BPProfilesInternalConfigComponent,

    // -- BP Wizard
    BPWizardComponent,
    BPWizardAgreementComponent,
    BPWizardBankComponent,
    BPWizardBillingMethodsComponent,
    BPWizardCompanyMarginComponent,
    BPWizardFeesComponent,
    BPWizardGeneralComponent,
    BPWizardOEMComponent,
    BPWizardPaymentSourceComponent,
    BPWizardPaymentTermsComponent,
    BPWizardThankYouComponent,
    BPWizardWelcomeComponent
  ],
  providers: [
    BPProfilesDataService,
    BPProfilesService,
    // -- BP advanced
    BPProfilesProductCatalogDataService,
    BPProfilesBankDataService,
    BPProfilesAccessSettingsDataService,
    BPProfilesAcslInfoDataService,
    BPProfilesContactsDataService,
    BPProfilesOEMService,
    BPProfilesOEMDataService,
    BPProfilesTCDataService,
    BPProfilesAccreditationsService,
    BPProfilesAccreditationsDataService,
    BPProfilesAuditDataService,
    BPProfilesCatalogDataService,
    BPProfilesCatalogService,
    BPProfilesDocumentsDataService,
    BPProfilesTicketsDataService,
    BPProfilesMailsDataService,
    BPProfilesMailsService,
    BPProfilesTerritoriesDataService,
    BPProfilesContractDataService,
    BPProfilesCaveatsDataService,
    BPProfilesSLADataService,
    BPProfilesSLAService,
    BPProfilesChecklistsDataService,
    BPProfilesAttributesService,

    // -- BP wizard
    BPWizardService
  ]
})
export class BPProfilesModule { /**/ }